import type { Cart, CartLight } from '@maestro/data-layer'

import { apiGet } from '@maestro/core/api-client'

export function loadCart(cartId: string): Promise<Cart> {
  return apiGet<Cart>('/api/cart/load', { cartId })
}

export function getUserCart(): Promise<Cart | null> {
  return apiGet<Cart | null>('/api/cart/user')
}

export function loadCartLight(cartId: string): Promise<CartLight> {
  return apiGet<CartLight>('/api/cart/cart-light', { cartId })
}
